import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsMedal03Small = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M21.9 4.51L19.67.33H4.39L2.14 4.57l3.49 6.58a8 8 0 1012.74.01zm-1.52 0L17.4 10.1s-.01-.02-.02-.02a7.994 7.994 0 00-1.99-1.33l3.62-6.8zm-6.27 3.77a8.09 8.09 0 00-4.22 0L8.22 5.15h7.56zm3.52-6.61L16.49 3.8H7.51L6.37 1.67zM3.67 4.57l1.36-2.56 3.59 6.74a7.96 7.96 0 00-2 1.33c-.01 0-.02.02-.02.02zm15 11.43a6.67 6.67 0 11-11.25-4.85 6.6 6.6 0 013.12-1.65 6.354 6.354 0 012.92 0 6.606 6.606 0 013.13 1.66A6.673 6.673 0 0118.67 16z" />
        <path d="M14.21 11.16a5.242 5.242 0 00-1.41-.42 4.603 4.603 0 00-1.6 0c-.486.075-.96.212-1.41.41a5.34 5.34 0 104.42.01zm-.54 3.64c.004.442-.157.87-.45 1.2.293.33.454.758.45 1.2v.6a1.875 1.875 0 01-3.75 0h1.35a.53.53 0 101.06 0v-.6a.534.534 0 00-.53-.53H11v-1.34h.8a.534.534 0 00.53-.53v-.6a.53.53 0 00-1.06 0H9.92a1.875 1.875 0 013.75 0z" />
      </g>
    </svg>
  )
);
SvgAchievementsMedal03Small.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgAchievementsMedal03Small.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsMedal03Small;
